<template>
	<div>
		<v-dialog v-model="dialog_mark" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">
        	<v-card flat>
        		<v-toolbar flat fixed>
			      <v-toolbar-side-icon @click="fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
			      <v-toolbar-title class="white--text">{{clearValue ? 'Close Pending Bill/Invoice' : 'Reopen Closed Bill/Invoice'}}</v-toolbar-title>
			      <v-spacer></v-spacer>
			      <v-btn icon small :disabled="disableBtn" @click="fn_openSheet" class="mr-2">Done</v-btn>

			      <v-text-field  flat solo placeholder="Search..." v-model="searchValue" slot="extension" ></v-text-field>
			    
				  <v-menu v-if="clearValue">
						<v-btn slot="activator" icon>
							<v-icon font20>more_vert</v-icon>
						</v-btn>

						<v-list densed two-line nopadding>

							<v-list-tile @click="$parent.fn_markClear(false)">
								<!-- <v-list-tile-action style="min-width: 36px;">
									<v-icon>refresh</v-icon>
								</v-list-tile-action> -->
								<v-list-tile-content>
									<v-list-tile-title>Reopen Closed Bill/Invoice</v-list-tile-title>	
									<v-list-tile-sub-title>Reopen Bill/Invoice from Closed List</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>

					</v-menu>
				
				</v-toolbar>


        		<v-card-text nopadding full-height style="padding-top:100px !important" id="scrollable-div">
					<v-alert class="pending_invoice" type="info" icon="info" transition="slide-y-transition" :value="true" v-if="showPendingAlert && clearValue">
						<div><span>Select pending bill/invoice to close or adjust.<br>Note: Selected item will be clear and will not appear in pending bills/invoices</span></div>
						<div right-align>
							<!-- <v-btn flat color="primary" class="primary--text" small>close</v-btn> -->
							<v-btn @click="fn_hidePendingInvoiceMessage" flat small capitalize><span class="primary--text">Okay, Got It</span></v-btn>
						</div>
					</v-alert>

					<v-alert class="pending_invoice" type="info" icon="info" transition="slide-y-transition" :value="true" v-if="showReopenAlert && !clearValue">
						<div><span>Select closed bill/invoice to reopen.<br>Note: Selected item will be reopen and will appear in pending bills/invoices</span></div>
						<div right-align>
							<!-- <v-btn flat color="primary" class="primary--text" small>close</v-btn> -->
							<v-btn @click="fn_hidePendingInvoiceMessage" flat small capitalize><span class="primary--text">Okay, Got It</span></v-btn>
						</div>
					</v-alert>
					<template v-if="filteredItems && filteredItems.length">
						<v-list nopadding>
							<v-list-tile>
								<v-list-tile-content>
									<v-list-tile-title light-opacity-color>Select All</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action style="padding-left: 24px;">
									<v-checkbox  @change="fn_selectAll" v-model="selectAll"></v-checkbox>
								</v-list-tile-action>
							</v-list-tile>
						</v-list>
						<v-divider></v-divider>
					</template>
					
        			<v-list two-line nopadding>
						<template v-for="(item, index) in filteredItems">
							<v-list-tile :key="index">
								<v-list-tile-content>
									<v-list-tile-title>{{item.baseTransactionNumber}} | {{item.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-title>
									<v-list-tile-sub-title>Bill Amount: &#8377; {{ $root.numberToLocale(item.billAmount) }} &nbsp;&nbsp; Due: &#8377; {{ $root.numberToLocale(item.outStandingAmount) }}</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action style="padding-left: 24px;">
									<v-checkbox v-model="item.selected" :value="item.selected" @change="fn_unselect(item, true)"></v-checkbox>
								</v-list-tile-action>
							</v-list-tile>
							<v-divider v-if="filteredItems.length - 1 != index"></v-divider>
						</template>
                        
                    </v-list>

        			<div class="display_msg" v-if="!filteredItems.length">There is no pending items</div>

        		</v-card-text>
        		<!-- <v-divider></v-divider>
		        <v-card-actions>
		        	Total
		        	<v-spacer></v-spacer>
          			&#8377; {{$root.numberToLocale(referenceTotal)}}
		        </v-card-actions> -->
        	</v-card>
      	</v-dialog>

		<v-bottom-sheet v-model="confirmSheet" persistent>
			<v-card flat>
				<v-card-text>
					<p>{{ clearValue ? 'These selected bills/invoices will be cleared.' : 'These selected bills/invoices will be reopen.' }}</p>
					<div style="overflow-y: scroll;max-height: 200px;padding-bottom: 16px;"><v-chip close @input="fn_unselect(item)" small v-for="(item, index) in pendingInvoices" :key="index" v-if="item.selected">{{ item.baseTransactionNumber }}</v-chip></div>
					<v-textarea 
						rows="2" 
						label="Enter Note" 
						placeholder=" " 
						v-model="clearNote">
					</v-textarea>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn small font-heavy class="primary-color" flat @click="confirmSheet=false">Cancel</v-btn>
					<v-btn small font-heavy class="primary-color" flat @click="fn_markClear">{{ this.clearValue ? 'Clear' : 'Reopen' }} All</v-btn>
				</v-card-actions>
			</v-card>
		</v-bottom-sheet>
	</div>
</template>

<script>

const transactionTypes = require('../../../../config.js').configs.transactionTypes;

export default{
	props:['partyId', 'showBottomNavigation', 'refreshList', 'clearValue'],
	data(){
		return{
			dialog_mark: false,
			searchValue:'',
			disableBtn:false,
			referenceTotal:0,
			hasAmountFilled:false,
			onAccount:0,
            pendingInvoices:[],
			selectAll:false,
			confirmSheet:false,
			clearNote:null,
			showPendingAlert:true,
			showReopenAlert:true
		}
	},
	methods:{
		openDialogWeb: function () {
			this.dialog_mark = true;
			this.selectAll = false;

			if(localStorage.getItem('pending_invoice')){
				this.showPendingAlert = false;
			}

			if(localStorage.getItem('reopen_invoice')){
				this.showReopenAlert = false;
			}
			// if(!this.$parent.Form.particularsData.onAccount && !this.$parent.Form.particularsData.references.length){
			// 	this.onAccount = this.$parent.Form.particularsData.amount;
			// }
			// else{
			// 	this.onAccount = this.$parent.Form.particularsData.onAccount;
			// }

			// making textbox empty and checkbox unchecked if no references save yet
			// setTimeout(() => {
			// 	this.fn_referenceTotal();
			// }, 500);

			this.searchValue = '';
			this.clearNote = null;
			// this.$validator.reset();
            this.fn_loadPendingItems();
		},
		closeDialogWeb: function () {
			this.dialog_mark = false;
			this.showBottomNavigation ? this.showBottomNavigation() : '';
		},
		fn_closeDialog: function(){
			if(this.$parent.fn_closeDialog){
				this.$parent.fn_closeDialog();
			}
			else{
				this.closeDialogWeb();
			}
		},
		onScroll: function () {
			let elements = document.getElementsByClassName('error--text');
			let scrollableDiv = document.getElementById('scrollable-div');
			scrollableDiv.scrollTop = elements[0].offsetTop - 120;
		},

		fn_selectAll: function(val){
			for(let i=0; i<this.pendingInvoices.length; i++){
				this.pendingInvoices[i].selected = val;
				this.$forceUpdate();
			}
		},

		fn_unselect: function(item, donotfalse){
			if(!donotfalse){
				item.selected = false;
			}
			this.$forceUpdate();
			this.fn_watchSelection();
		},

        fn_loadPendingItems: function () {

            let filterObject = {};

			if(this.partyId){
				filterObject.formTransactionListId = [this.$parent.Form.transactionData.transactionListId];
			}
			else{
				filterObject.formTransactionListId = [30001, 30002];
			}

            filterObject.transactionListId = [transactionTypes.salesInvoice.id, transactionTypes.salesReturn.id, transactionTypes.bwbRefPurchaseInvoice.id, transactionTypes.bwbRefSaleInvoice.id, transactionTypes.purchaseInvoice.id, transactionTypes.purchaseReturn.id, transactionTypes.expense.id, transactionTypes.bwbRefPurchaseInvoice.id, transactionTypes.bwbRefSaleInvoice.id];

            // if(this.Form.transactionData.transactionListId == transactionTypes.receipt.id){
            //     filterObject.transactionListId = [transactionTypes.salesInvoice.id, transactionTypes.salesReturn.id, transactionTypes.bwbRefPurchaseInvoice.id, transactionTypes.bwbRefSaleInvoice.id];
            // }
            // else if(this.Form.transactionData.transactionListId == transactionTypes.payment.id){
            //     filterObject.transactionListId = [transactionTypes.purchaseInvoice.id, transactionTypes.purchaseReturn.id, transactionTypes.expense.id, transactionTypes.bwbRefPurchaseInvoice.id, transactionTypes.bwbRefSaleInvoice.id];
            // }

            let self = this;
			let fnName = this.clearValue ? 'PendingReferences' : 'ClearedReferences';
            this.getFilterData(fnName, this.partyId ? this.partyId : null, filterObject, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.pendingInvoices = JSON.parse(response);
						self.pendingInvoices.forEach(function(item){
							item.selected = false;
						})

                        //setting up max value to be filled and amount type dr/cr
                        // self.Form.references.forEach(function(item){
                        //     item.maxValue = item.outStandingAmount;

                        //     if(item.transactionListId == transactionTypes.purchaseInvoice.id || item.transactionListId == transactionTypes.expense.id || item.transactionListId == transactionTypes.salesReturn.id){
                        //             item.amountType = 1;
                        //     }
                        //     else if(item.transactionListId == transactionTypes.salesInvoice.id || item.transactionListId == transactionTypes.purchaseReturn.id){
                        //         item.amountType = 0;
                        //     }

                        // });

                        // //Appending amount if any
                        // for(let i=0; i<self.Form.particularsData.references.length; i++){

                        //     for(let j=0; j<self.Form.references.length; j++){

                        //     if(self.Form.particularsData.references[i].baseTransactionId == self.Form.references[j].baseTransactionId && self.Form.particularsData.references[i].baseTransactionNumber == self.Form.references[j].baseTransactionNumber){

                        //             self.$set(self.Form.references[j], 'amount', self.Form.particularsData.references[i].amount)

                        //             let amount = 0;
                        //             if(!this.isNew){
                        //                 self.Form.references[j].amount ? amount = self.Form.references[j].amount : '';
                        //                 self.Form.references[j].outStandingAmount = amount + self.Form.references[j].outStandingAmount;
                        //                 self.Form.references[j].maxValue = self.Form.references[j].outStandingAmount;
                        //             }

                        //             self.$forceUpdate();
                        //             break;
                        //     }
                            
                        //     }	

                        // }

                        // self.fn_openDialogReferences();
                        
                    }, 
                    onError: function(error){
                    console.log(error);
                    }
                }
            );
        },

		fn_markClear: function(){

			var self = this;
			let dataObj = {"transactionIds":[]};
			let selectedItems = this.pendingInvoices.filter(item=>{ return item.selected});
			if(selectedItems && selectedItems.length){
				for(let i=0; i<selectedItems.length; i++){
					dataObj.transactionIds.push(selectedItems[i].baseTransactionId)
				}

				dataObj.markClear = this.clearValue;
				dataObj.markClearNote = this.clearNote;

				this.postData('UpdateMarkClear', dataObj, 
				{
					onSuccess: function(response){
						console.log(response);
						self.showToast(self.clearValue ? 'Cleared Successfully' : 'Reopened Successfully');
						self.confirmSheet=false;
						self.refreshList ? self.refreshList() : '';
						self.fn_closeDialog();
					},
					onError: function(error){
						console.log(error);
						self.showToast('Something went wrong');
					}
				});
			}
			else{
				this.showToast('Select transaction');
				this.confirmSheet = false;
			}
		},

		fn_watchSelection: function(){
			let selectedItems = this.pendingInvoices.filter(item=>{
				return item.selected;
			})
			if(!selectedItems || !selectedItems.length){
				this.selectAll = false;
			}
		},

		fn_saveFilledReferences: function () {
			// if(this.referenceTotal<=0){
			// 	if(this.hasAmountFilled){
			// 		this.showToast("Total should not be negative or zero");
			// 	}
			// 	else{
			// 		this.$parent.fn_closeDialog();	
			// 	}
			// 	return;
			// }

			this.disableBtn = true;
		    this.$validator.validateAll('fields').then((result) => {

				if(!this.onAccount){
					this.$parent.Form.amount = this.referenceTotal;
					this.$parent.fn_autoFillPaymentMode(this.$parent.Form.amount);
				}
				else{
					this.$parent.Form.particularsData.onAccount = this.roundUpto2Decimals(this.$parent.Form.amount - this.referenceTotal);
				}

				this.saveFilledReferences();

		    	// if(this.referenceTotal > this.$parent.Form.particularsData.amount){
				// if(this.referenceTotal > this.$parent.Form.amount){
	    		// 	this.disableBtn = false;
	    		// 	this.showToast("Reference total amount shouldn't greater than amount");
	    		// }
	    		// else{
	    		// 	// this.$parent.Form.particularsData.onAccount = this.roundUpto2Decimals(this.$parent.Form.particularsData.amount - this.referenceTotal);
				// 	this.$parent.Form.particularsData.onAccount = this.roundUpto2Decimals(this.$parent.Form.amount - this.referenceTotal);
	        	// 	this.saveFilledReferences();
	    		// }

		    	// if(this.referenceTotal>0){
		    	// 	if(this.referenceTotal > this.$parent.Form.particularsData.amount){
		    	// 		this.disableBtn = false;
		    	// 		this.showToast("Reference total amount shouldn't greater than amount");
		    	// 	}
		    	// 	else{
		    	// 		this.$parent.Form.particularsData.onAccount = this.roundUpto2Decimals(this.$parent.Form.particularsData.amount - this.referenceTotal);
		     //    		this.saveFilledReferences();
		    	// 	}
		    	// }
		    	// else{
		    	// 	this.disableBtn = false;
		    	// 	this.showToast("Invalid reference total");
		    	// }

		    });
		},
		// fn_selectAllReferences: function(val){
		// 	for(let i in this.filteredItems){
		// 		val ? this.filteredItems[i].amount = this.filteredItems[i].outStandingAmount : this.filteredItems[i].amount = null;
		// 	}
		// 	this.fn_referenceTotal();
		// },

		fn_autoFillAmount: function(selected, item){

			// if(item.amount == item.outStandingAmount){
			// let remainingAmount = this.$parent.Form.particularsData.amount - this.referenceTotal;
			let remainingAmount = this.$parent.Form.amount - this.referenceTotal;

			if(!selected){
				item.amount = null;
				// this.selectAllRef = false;
			}
			else{
				// if(this.referenceTotal < this.$parent.Form.particularsData.amount){
				if(this.referenceTotal < this.$parent.Form.amount){
					if(item.outStandingAmount > remainingAmount){
						item.amount = remainingAmount;
					}
					else{
						item.amount = item.outStandingAmount;
					}

					// item.amount = this.$parent.Form.particularsData.amount;
				}
				else{
					item.amount = item.outStandingAmount;
				}
				
				// if(item.amount != item.outStandingAmount){
					
				// 	if(item.outStandingAmount > this.$parent.Form.particularsData.amount){
				// 		item.amount = this.$parent.Form.particularsData.amount;
				// 	}
				// 	else{
				// 		item.amount = item.outStandingAmount;
				// 	}
					
				// }
				// else{
				// 	item.amount = null;
				// }
			}

			// if(item.amount != item.outStandingAmount){
			// 	item.amount = item.outStandingAmount;
			// }
			// else{
			// 	item.amount = null;
			// 	this.selectAllRef = false;
			// }

			this.fn_referenceTotal();
		},
		// fn_changeAmount: function(item){
		// 	if(item.amount == item.outStandingAmount)
		// 		item.autoFill = true;
		// 	else
		// 		item.autoFill = false;

		// 	this.fn_referenceTotal();
		// },
		fn_referenceTotal: function(){
			let referenceTotal = 0;
			this.hasAmountFilled = false;
			// this.isEmptyAmountField = true;

			if(this.filteredItems && this.filteredItems.length){
				for(let i=0; i<this.filteredItems.length; i++){

					let prefix = this.getPrefix(this.filteredItems[i].transactionListId);

					if(this.filteredItems[i].amount){

						this.hasAmountFilled = true;

						// calculating reference total
						if(prefix=='minus'){
							referenceTotal -= this.filteredItems[i].amount;
						}
						else{
							referenceTotal += this.filteredItems[i].amount;
						}

					}
				}
			}

			// let onAccount = 0;

			// if(this.onAccount){
			// 	onAccount = this.onAccount;
			// 	this.isEmptyAmountField = false;
			// }
			
			this.referenceTotal = this.roundUpto2Decimals(referenceTotal);

			if(this.$parent.Form.amount){
				if(this.referenceTotal > this.$parent.Form.amount){
					this.onAccount = this.referenceTotal;
				}
				else{
					this.onAccount =  this.$parent.Form.amount - this.referenceTotal;
				}
			}

			// if(this.referenceTotal > this.$parent.Form.particularsData.amount){
			// if(this.referenceTotal > this.$parent.Form.amount){
			// 	this.showToast("Reference total amount shouldn't greater than amount");
			// 	this.showToast("Please adjust references as per amount");
			// }
		},

		fn_openSheet: function(){
			this.confirmSheet = true;
		},

		fn_hidePendingInvoiceMessage: function(){
			if(this.clearValue){
				this.showPendingAlert = false;
				localStorage.setItem("pending_invoice", 1);
			}
			else{
				this.showReopenAlert = false;
				localStorage.setItem("reopen_invoice", 2);
			}
		}
	},
	computed:{
		filteredItems: function () {
	        let searchText = this.searchValue.toLowerCase();

	        if(this.pendingInvoices && this.pendingInvoices.length){

	        	return this.pendingInvoices.filter(item => {
		          // let name = item.name.toLowerCase();
		          let keyword = searchText.toLowerCase();

		          // let transactionNumberString = item.baseTransactionNumber ? item.baseTransactionNumber.toLowerCase() : '';
		          let transactionNumberString = ''

		          if(item.baseTransactionNumber){
		          	transactionNumberString = item.baseTransactionNumber.toLowerCase();
		          }
		          else if(item.baseRefNumber){
		          	transactionNumberString = item.baseRefNumber.toLowerCase();	
		          }

		          return transactionNumberString.match(keyword);
		        });
		        
		    }
		    else{
	        	return [];
	        }
	    }
	    // disableReferences: function(){
	    // 	if(this.$parent.Form.particularsData.amount == this.referenceTotal){
	    // 		return true;
	    // 	}
	    // 	else{
	    // 		return false;
	    // 	}
	    // }
	 //    referenceTotal: function(){
		// 	let total = 0;

		// 	if(this.filteredItems && this.filteredItems.length){
		// 		for(let i=0; i<this.filteredItems.length; i++){

		// 			let prefix = this.getPrefix(this.filteredItems[i].transactionListId);

		// 			if(this.filteredItems[i].amount){

		// 				if(prefix=='minus'){
		// 					total -= this.filteredItems[i].amount;
		// 				}
		// 				else{
		// 					total += this.filteredItems[i].amount;
		// 				}

		// 			}
		// 		}
		// 	}
			
		// 	return this.roundUpto2Decimals(total);
		// }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_mark_invoice_clear.vue